import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const password = control.value;
        if (password == null || password === "") {
            return null;
        }

        const validationError = passwordValidator.getError(String(password));
        if (!validationError) {
            return null;
        }

        return { [validationError]: true };
    };
}

export namespace passwordValidator {
    export const MinLength = 5;
    export const MaxLength = 128;
    export const Pattern = /^[\x20-\x7E]+$/;

    export const LengthMessage = "Passwords must be 5–128 characters in length.";
    export const CharactersMessage = "Passwords may include letters, numbers, spaces, and common symbols.";
    export const WhitespaceMessage = "Passwords cannot start or end with spaces.";
    export const HintMessage = `${LengthMessage} ${CharactersMessage}`;

    export type Error = "too-short" | "too-long" | "invalid-characters" | "leading-trailing-whitespace";

    export function getError(password: string): Error | undefined {
        if (password.length < MinLength) {
            return "too-short";
        }
        if (password.length > MaxLength) {
            return "too-long";
        }
        if (password !== password.trim()) {
            return "leading-trailing-whitespace";
        }
        if (!Pattern.test(password)) {
            return "invalid-characters";
        }
        return undefined;
    }

    export function getMessage(error: Error): string {
        switch (error) {
            case "too-short":
            case "too-long":
                return LengthMessage;
            case "invalid-characters":
                return CharactersMessage;
            case "leading-trailing-whitespace":
                return WhitespaceMessage;
        }
    }
}
